export default __webpack_public_path__ + "static/media/Here Comes The Sun.a390445c.mp3";